export default "__VITE_ASSET__DXiNucEc__"